// extracted by mini-css-extract-plugin
module.exports = {"wojnndj":"wojnndj","hvw37ip":"hvw37ip","c196by4d":"c196by4d"};